<template>
    <div class="min-h-[100vh] flex flex-col items-center p-6 md:p-0">
        <nav class="bg-white w-full">
            <div
                class="container mx-auto px-4 py-2 flex items-center justify-between"
            >
                <a href="/">
                    <img src="/logo/logo.png" alt="Amana Logo" class="h-12" />
                </a>
                <div>
                    <p class="font-bold">Select Market</p>
                </div>
                <div
                    class="flex items-center space-x-2 cursor-pointer font-bold"
                    @click="() => handlePrevious()"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-5 w-5"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                    >
                        <path
                            fill-rule="evenodd"
                            d="M10 19a1 1 0 01-.7-.29l-7-7a1 1 0 010-1.42l7-7a1 1 0 111.4 1.42L4.42 10l6.3 6.29a1 1 0 01-.7 1.71z"
                            clip-rule="evenodd"
                        />
                    </svg>
                    <p>Go Back</p>
                </div>
            </div>
            <div class="w-full h-px bg-gray-300"></div>
        </nav>

        <div
            class="w-full rounded-lg overflow-hidden flex flex-col items-center mt-10 md:mt-0"
        >
            <BreadCrumb
                :iconURL="iconURL"
                :headingTex="headingTex"
                :subText="subText"
            />

            <div class="w-full max-w-sm mt-2 z-20">
                <div class="mb-1">
                    <label for="state" class="block text-sm font-medium"
                        >Markets</label
                    >
                    <select
                        v-model="formData.market_id"
                        id="state"
                        class="mt-1 block w-full px-4 py-2 border bg-white border-gray-300 rounded-lg shadow-sm focus:ring-[#41AE49] focus:border-[#41AE49]"
                    >
                        <option value="">Select Market</option>
                        <option
                            v-for="market in markets"
                            :key="market.id"
                            :value="market.id"
                        >
                            {{ market.name }}
                        </option>
                    </select>
                    <p v-if="errors.market" class="text-red-500 text-sm">
                        {{ errors.market }}
                    </p>
                </div>

                <div class="flex justify-end gap-2 my-2">
                    <button
                        @click="() => handlePrevious()"
                        type="submit"
                        class="w-full py-2 px-4 bg-white border border-gray-500 font-semibold rounded-lg hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-[#41AE49]"
                    >
                        Previous
                    </button>
                    <button
                        @click="handleNext"
                        :disabled="isLoading"
                        class="w-full py-2 px-4 bg-[#41AE49] text-white font-semibold rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-[#41AE49]"
                    >
                        <span v-if="isLoading">Processing...</span>
                        <span v-else>Next</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, inject, watch, onMounted } from "vue";
import BreadCrumb from "./components/BreadcrumbVue.vue";
import api from "@/services/api";

const iconURL = "/icons/information.png";
const headingTex = "Join an existing market";
const subText = "Select from the list of verified markets";
const isLoading = ref(false);
const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
const formData = inject("formData");
const isFormValid = ref(false);
const markets = ref([]);

const { currentStep, updateCurrentStep } = inject("currentStep");
const showSuccess = inject("showSuccess");
const showError = inject("showError");

const handleNext = async () => {
    isLoading.value = true;
    errors.value = {};
    const data = {
        payload: {
            market_id: formData.value.market_id,
        },
    }

    try {
        const response = await api.patch(
            `/signup/activities/${formData.value.id}/update`,
            data,
        );
        updateCurrentStep(response?.data?.data?.current_step);
        showSuccess("Market Selected")
    } catch (error) {
        showError(error.response.data.errors)
        console.error(error);
    } finally {
        isLoading.value = false;
    }
};


const handlePrevious = async () => {
    isLoading.value = true;
    errors.value = {};

    try {
        const response = await api.patch(
            `/msignup/activities/${formData.value.id}/update`,
            {
                current_step: currentStep.value -1,
               
            },
        );
        updateCurrentStep(response?.data?.data?.current_step);
    } catch (error) {
        console.error(error);
    } finally {
        isLoading.value = false;
    }
};

const errors = ref({});
const isDropdownOpen = ref(false);

const validateForm = () => {
    errors.value = {};

    if (!formData.value.market_name) {
        errors.value.market_name = "Organization name is required.";
    }
    if (!formData.value.phone) {
        errors.value.phone = "Phone number is required.";
    }
    if (formData.value.email && !emailPattern.test(formData.value.email)) {
        errors.value.email = "Please enter a valid email.";
    }
    isFormValid.value = Object.keys(errors.value).length === 0;
};

watch(formData, validateForm, { deep: true });

const fetchMarkets = async () => {
    try {
        const { data } = await api.get(`/api/markets`);
        markets.value = data;
    } catch (e) {
        console.error("Failed to load markets:", e);
    }
};

onMounted(() => {
    fetchMarkets();
});
</script>
